import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { classNames } from '../helpers/functions';
import Tooltip from '../Tooltip';

const Container = ({ tooltip, children, message, i = 1 }) =>
	tooltip ? (
		<Tooltip message={message} i={i}>
			{children}
		</Tooltip>
	) : (
		children
	);

const Pill = ({
	status = 'default',
	children,
	onClick,
	tooltip,
	onClose,
	addIcon,
	className,
}) => {
	const statusMapping = {
		default: {
			border: '',
		},
		error: {
			border: 'border b-red-600',
		},
	}[status];

	return (
		<div
			className={classNames(
				'text-xxs border rounded-2xl py-2 px-3 text-gray-500 mr-2 mb-2 w-fit',
				statusMapping?.border,
				onClick ? 'cursor-pointer' : '',
				className
			)}
			onClick={(e) => (typeof onClick === 'function' ? onClick(e) : {})}
		>
			<div className="flex items-center">
				<Container message={tooltip} tooltip={!!tooltip}>
					<div className="flex">
						{addIcon && (
							<PlusIcon
								className={classNames(
									'w-4 h-4 text-gray-500',
									children && 'mr-2'
								)}
							/>
						)}

						{children}
					</div>
				</Container>

				{onClose && (
					<XMarkIcon
						className="w-4 h-4 text-gray-500 ml-2  cursor-pointer"
						onClick={() => onClose()}
					/>
				)}
			</div>
		</div>
	);
};

export default Pill;
